import { Directive, ElementRef, Input, OnChanges, OnDestroy, Optional, SimpleChanges } from '@angular/core';
import { from, Subject, takeUntil } from 'rxjs';

import { BlobCacheService } from 'src/app/services/blob-cache.service';
import { IntersectionService } from 'src/app/services/intersection.service';

@Directive({
    selector: '[blobImage]',
    standalone: true
})
export class BlobImageDirective implements OnChanges, OnDestroy {

    @Input('blobImage') imageUrl?: string;
    @Input() lazyLoad: boolean = false;

    private interruptSubject: Subject<void> = new Subject();

    constructor(
        private elem: ElementRef<HTMLImageElement>,
        private blobCacheService: BlobCacheService,
        @Optional() private intersectionService?: IntersectionService) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['imageUrl'] || changes['lazyLoad']) {
            this.interruptSubject.next();

            if (this.imageUrl) {
                if (this.lazyLoad) {
                    this.assertIntersectionService();

                    this.intersectionService.observeIntersected(this.elem.nativeElement)
                        .pipe(takeUntil(this.interruptSubject))
                        .subscribe(() => {
                            this.fetchBlobImage();
                        });
                }
                else {
                    this.fetchBlobImage();
                }
            }
            else {
                this.elem.nativeElement.src = '';
            }
        }
    }

    ngOnDestroy() {
        this.interruptSubject.next();
        this.interruptSubject.complete();
    }

    private assertIntersectionService() {
        if (!this.intersectionService) {
            throw new Error('[BlobImageDirective] IntersectionService is not provided.');
        }
    }

    private fetchBlobImage() {
        from(this.blobCacheService.getBlobUrl(this.imageUrl))
            .pipe(takeUntil(this.interruptSubject))
            .subscribe(result => {
                this.elem.nativeElement.src = result;
            });
    }
}
